import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authActions } from "../../store";
import LanguageSwitcher from "./LanguageSwitcher";
import StockAlertsBell from "./StockAlertsBell";
import ValorcarBell from "./ValorcarBell";
import NotificationsBell from "./NotificationsBell";
import { useTranslation } from "react-i18next";
import { profileDetailForWeb } from "../../services/AuthServices";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getSettingsCompanyDetails } from "../../services/settingsServices";
import ConfigDB from "../../config";
import { getpendingSales } from "../../services/SalesServices";
import { logoutCurrentSession } from "../../services/SessionsService";

const Header = ({ isOpenS, setIsOpens }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [profileDetails, setProfileDetails] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const location = useLocation();
  const { t } = useTranslation();
  const UserImages = "https://tp.software/libs/img/logo-letters.png";
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const isAdmin = JSON.parse(data);
  const [salesDetails, setSalesDetails] = useState("");
  const isApp = Number(localStorage.getItem("isApp"));

  let title;
  if (location.pathname === "/dashboard") {
    title = t("dashboard");
  } else if (location.pathname === "/vehicle-process") {
    title = t("vehicle");
  } else if (location.pathname === "/parts-inventory") {
    title = t("Parts Inventory");
  } else if (location.pathname === "/ler-catalog") {
    title = t("LER Catalog");
  } else if (location.pathname === "/depollution-operation") {
    title = t("Depollution Opration");
  } else if (location.pathname === "/User") {
    title = t("User");
  } else if (location.pathname === "/Roles") {
    title = t("Roles");
  } else if (location.pathname === "/fuel-type") {
    title = t("Fuel");
  } else if (location.pathname === "/part-type") {
    title = t("Part Type");
  } else if (location.pathname === "/part-location") {
    title = t("Part Location");
  } else if (location.pathname === "/part-group") {
    title = t("Part Group");
  } else if (location.pathname === "/part-sides") {
    title = t("Part Sides");
  } else if (location.pathname === "/vehicle-category") {
    title = t("vehicle_category");
  } else if (location.pathname === "/vehicle-type") {
    title = t("Vehicle Type");
  } else if (location.pathname === "/vehicle-model") {
    title = t("vehicle_model");
  } else if (location.pathname === "/faqs") {
    title = t("FAQ");
  } else if (location.pathname === "/terms-condition-admin") {
    title = t("Terms & Condition");
  } else if (location.pathname === "/privacy-policy-admin") {
    title = t("Privacy & Policy");
  } else if (location.pathname === "/part-catalog") {
    title = t("Part Catalog");
  } else if (location.pathname === "/park") {
    title = t("Park");
  } else if (location.pathname === "/shelf") {
    title = t("Shelf");
  } else if (location.pathname === "/certificate") {
    title = t("Certificate");
  } else if (location.pathname === "/warehouse-entity-type") {
    title = t("Warehouse Entity");
  } else if (location.pathname === "/warehouse") {
    title = t("Warehouse");
  } else if (location.pathname === "/label-templates") {
    title = t("label_templates");
  } else if (location.pathname === "/vehicle-make") {
    title = t("Vehicle Make");
  } else if (location.pathname === "/vehicle-engine") {
    title = t("vehicle_engine");
  } else if (location.pathname === "/vehicle-variants") {
    title = t("Vehicle Variants");
  } else if (location.pathname === "/sales") {
    title = t("Sales");
  } else if (location.pathname === "/part-location-asssign") {
    title = t("part_location_assign");
  } else if (location.pathname === "/print") {
    title = "Print";
  } else if (location.pathname === "/warehouse-type") {
    title = "WareHouse Type";
  } else if (location.pathname === "/client-profile") {
    title = "Client";
  } else if (location.pathname === "/categories") {
    title = "Category";
  } else if (location.pathname === "/internal-sales") {
    title = t("internal_sales");
  } else if (location.pathname === "/reserves") {
    title = t("reserves");
  } else if (location.pathname === "/tasks") {
    title = t("task");
  } else if (location.pathname === "/task-report") {
    title = t("task_report");
  } else if (location.pathname === "/repairs-parts") {
    title = t("repairs_parts");
  } else if (location.pathname === "/history-repairs-process") {
    title = t("history_repairs_parts");
  } else if (location.pathname === "/check-list-vehicles") {
    title = t("vehicle_part_check_list");
  }

  const profileDropdownRef = useRef(null);

  // Close profile dropdown on outside click / Esc
  useEffect(() => {
    if (!isOpen) return;
    const onClick = (e) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const onKey = (e) => { if (e.key === "Escape") setIsOpen(false); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    try {
      await logoutCurrentSession();
    } catch (e) {
      // Ignorar: se o token já é inválido, não queremos bloquear o logout local
    }
    localStorage.removeItem("@secure.@data");
    localStorage.removeItem("lastVisitedPage");
    localStorage.removeItem("searchValue");
    localStorage.removeItem("profileDetails");
    localStorage.removeItem("isApp");
    dispatch(authActions.setAuth(null));
    navigate("/", { replace: true });
  };

  useEffect(() => {
    profileDetailForWeb()
      .then((response) => {
        setProfileDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (isAdmin?.default_user === 1) {
      getpendingSales()
        .then((response) => {
          setSalesDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [isAdmin?.default_user]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  const toggleSidebar = () => {
    setIsOpens(!isOpenS);
  };
  return (
    <div className="wrapper-dashboard">
      <nav
        className="main-header navbar navbar-expand navbar-white navbar-light"
        style={{ marginLeft: isOpenS ? "250px" : "60px" }}
      >
        {/* <div
            onClick={toggleSidebar}
            className="brand-link toggleBar toggleBar-custom"
          >
            <i className="bi bi-list"></i>
          </div> */}

        <h5>{title}</h5>
        <ul className="navbar-nav ml-auto">
          {salesDetails?.totalMarketSalesRecords > 0 && (
            <li className="nav-item dropdown hoverDropdown me-2">
              <button
                style={{ marginLeft: "12px" }}
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  navigate("/sales", { state: { order_status: 1 } });
                }}
              >
                MarketPlaces Sales {salesDetails.totalMarketSalesRecords}
              </button>
            </li>
          )}

          {salesDetails?.totalSalesRecords > 0 && (
            <li className="nav-item dropdown hoverDropdown me-3">
              <button
                style={{ marginLeft: "12px" }}
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  navigate("/internal-sales");
                }}
              >
                Internal Sales {salesDetails.totalSalesRecords}
              </button>
            </li>
          )}

          {!isApp && <NotificationsBell />}
          {!isApp && <StockAlertsBell />}
          {!isApp && <ValorcarBell />}

          {!isApp && (
            <>
              <li
                className="nav-item dropdown hoverDropdown"
                style={{ marginRight: "8px" }}
              >
                <a
                  href="https://printer.tp.software"
                  target="_blank"
                  rel="noreferrer"
                  className="tp-header-desktop-cta"
                  title={t("header_desktop_app_title")}
                >
                  <span
                    className="tp-header-desktop-cta-pulse"
                    aria-hidden="true"
                  ></span>
                  <i
                    className="bi bi-download"
                    style={{ marginRight: 8 }}
                  ></i>
                  <span className="tp-header-desktop-cta-label">
                    {t("header_desktop_app_label")}
                  </span>
                  <span className="tp-header-desktop-cta-badge">
                    {t("header_desktop_app_badge")}
                  </span>
                </a>
              </li>
              <li
                className="nav-item dropdown hoverDropdown"
                style={{ marginRight: "8px" }}
              >
                <LanguageSwitcher profileDetails={profileDetails} />
              </li>
            </>
          )}

          {!isApp && (
            <li
              className="nav-item"
              style={{ position: "relative" }}
              ref={profileDropdownRef}
            >
              <button
                type="button"
                onClick={toggleDropdown}
                aria-expanded={isOpen}
                aria-haspopup="menu"
                className="tp-profile-trigger"
              >
                <img
                  src={
                    profileDetails?.profile
                      ? profileDetails?.profile
                      : UserImages
                  }
                  alt="user"
                />
                <span className="tp-profile-trigger-name">
                  {profileDetails?.name || ""}
                </span>
                <i
                  className="bi bi-chevron-down"
                  style={{
                    fontSize: 12,
                    opacity: 0.7,
                    transition: "transform .2s",
                    transform: isOpen ? "rotate(180deg)" : "none",
                  }}
                />
              </button>
              {isOpen && (
                <div className="tp-profile-menu" role="menu">
                  <div className="tp-profile-menu-head">
                    <img
                      src={
                        profileDetails?.profile
                          ? profileDetails?.profile
                          : UserImages
                      }
                      alt=""
                    />
                    <div>
                      <div className="tp-profile-menu-name">
                        {profileDetails?.name || "—"}
                      </div>
                      <div className="tp-profile-menu-email">
                        {profileDetails?.email || ""}
                      </div>
                    </div>
                  </div>
                  <div className="tp-profile-menu-sep" />
                  <a
                    className="tp-profile-menu-item"
                    href="/profile"
                    onClick={() => setIsOpen(false)}
                  >
                    <i className="bi bi-person" /> {t("profile")}
                  </a>
                  <a
                    className="tp-profile-menu-item"
                    href="/profile/security"
                    onClick={() => setIsOpen(false)}
                  >
                    <i className="bi bi-shield-lock" /> {t("security_and_sessions")}
                  </a>
                  <a
                    className="tp-profile-menu-item"
                    href="/profile/notifications"
                    onClick={() => setIsOpen(false)}
                  >
                    <i className="bi bi-bell" /> Notificações
                  </a>
                  <a
                    className="tp-profile-menu-item"
                    href="/profile/notifications/preferences"
                    onClick={() => setIsOpen(false)}
                  >
                    <i className="bi bi-sliders" /> Preferências de notificações
                  </a>
                  <a
                    className="tp-profile-menu-item"
                    href="/settings"
                    onClick={() => setIsOpen(false)}
                  >
                    <i className="bi bi-gear" /> {t("settings")}
                  </a>
                  <div className="tp-profile-menu-sep" />
                  <button
                    type="button"
                    className="tp-profile-menu-item tp-profile-menu-logout"
                    onClick={(e) => {
                      setIsOpen(false);
                      handleLogout(e);
                    }}
                  >
                    <i className="bi bi-box-arrow-right" /> {t("logout")}
                  </button>
                </div>
              )}
            </li>
          )}
        </ul>
      </nav>

    </div>
  );
};

export default Header;
